import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { NewsSecondary } from '../News/NewsBlock';

import './news-relevant.scss';

class NewsRelevant extends PureComponent {
  render() {
    return (
      <div className="news-relevant">
        <div className="container">
          <h3>Возможно, вам будет интересно:</h3>

          <ul>
            {this.props.posts.map((item, key) =>
              <li key={key}>
                <NewsSecondary
                  post={item}
                  pathname={this.props.pathname}
                />
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  }
}

NewsRelevant.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object),
  pathname: PropTypes.string.isRequired
};

export default NewsRelevant;



// WEBPACK FOOTER //
// ./src/components/NewsPost/NewsRelevant.js